import { render, staticRenderFns } from "./GraphEdges.vue?vue&type=template&id=d5773da8&scoped=true&"
import script from "./GraphEdges.vue?vue&type=script&lang=ts&"
export * from "./GraphEdges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5773da8",
  null
  
)

export default component.exports